export const MaxBytesForFreeUsersUpload = 2147483648;
export const tableCategories = [
  {
    className: "code-id",
    constKey: "code",
    fieldName: null,
  },
  {
    className: "code-status",
    constKey: "status",
    fieldName: "ConfirmCode_Used",
  },
  {
    className: "code-purchase",
    constKey: "purchase-date",
    fieldName: "ConfirmCode_Create_Date",
  },
  {
    className: "code-usage",
    constKey: "usage-date",
    fieldName: "ConfirmCode_Date_Used",
  },
  {
    className: "code-usage-type",
    constKey: "usage-type",
    fieldName: null
  },
];

// export const statusUsed = [
//   {
//     enName: "All statuses",
//     constName: getTextByKey("profilecodes-table-all-statuses"),
//   },
//   {
//     enName: "Available",
//     constName: getTextByKey("profilecodes-table-status-available"),
//   },
//   {
//     enName: "Used",
//     constName: getTextByKey("profilecodes-table-status-used"),
//   },
//   {
//     enName: "Cancelled",
//     constName: getTextByKey("profilecodes-table-status-canceled"),
//   },
// ];

// export const statusUsedDisplay = [
//   getTextByKey("profilecodes-table-all-statuses"),
//   getTextByKey("profilecodes-table-status-available"),
//   getTextByKey("profilecodes-table-status-used"),
//   getTextByKey("profilecodes-table-status-canceled"),
// ];

